import React, { Component } from 'react'
import Portabella from '../../Images/Mushroom/tms-portabella.webp'
import Portabella8000 from '../../Images/Mushroom/tms-portabella-8000.webp'
import Portabella8000i from '../../Images/Mushroom/tms-portabella-8000i.webp'
import Portabella4000i from '../../Images/Mushroom/tms-portabella-4000i.webp'
import Portabella2000i from '../../Images/Mushroom/tms-portabella-2000i.webp'
import StreamerPro from '../../Images/Mushroom/tms-streamer-pro.webp'
import TruffleBroadband from '../../Images/Mushroom/tms-truffle-broadband.webp'
import TruffleEx from '../../Images/Mushroom/tms-truffle-ex.webp'

class MushroomProducts extends Component {
    render() {
        return (
            <div id="m-products">
                <h3 className="w-100 text-center mb-4">
                    MUSHROOM NETWORKS PRODUCTS
                </h3>
                <div className='m-products-body'>
                    <div className="one" data-toggle="modal" data-target="#portabella">
                        <img src={Portabella} alt="mushroom-tmsarge-1" title="mushroom-tmsarge-1" />
                        <p >PORTABELLA</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella8000">
                        <img src={Portabella8000} alt="mushroom-tmsarge-2" title="mushroom-tmsarge-2" />
                        <p >PORTABELLA 8000 BROADBAND BONDING APPLICANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella8000i">
                        <img src={Portabella8000i} alt="mushroom-tmsarge-3" title="mushroom-tmsarge-3" />
                        <p >PORTABELLA 8000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella4000i">
                        <img src={Portabella4000i} alt="mushroom-tmsarge-4" title="mushroom-tmsarge-4" />
                        <p >PORTABELLA 4000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#portabella2000i">
                        <img src={Portabella2000i} alt="mushroom-tmsarge-5" title="mushroom-tmsarge-5" />
                        <p >PORTABELLA 2000i SERIES BROADBAND BONDING APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#streamerpro">
                        <img src={StreamerPro} alt="mushroom-tmsarge-6" title="mushroom-tmsarge-6" />
                        <p >STREAMER PRO</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#trufflebroadband">
                        <img src={TruffleBroadband} alt="mushroom-tmsarge-7" title="mushroom-tmsarge-7" />
                        <p >TRUFFLE BROADBAND BONDING NETWORK APPLIANCE</p>
                    </div>
                    <div className="one" data-toggle="modal" data-target="#truffleex">
                        <img src={TruffleEx} alt="mushroom-tmsarge-8" title="mushroom-tmsarge-8" />
                        <p >TRUFFLE-EX</p>
                    </div>
                </div>

                <div className="modal fade" id="portabella" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella} className="popup-img"
                                            alt="tms-portabella" title="tms-portabella" />
                                    </div>

                                </div>
                                <div>
                                    <h6> 3G/4G/LTE/5G Bonding</h6>
                                    <p>Portabella is a Broadband Bonding™ appliance that combines and intelligently manages 2, 4 or 8 cellular SIM connections from any of your service providers. Portabella can stripe a single session over the available paths and therefore create a single super-fast pipe by using our cloud relay service.</p>
                                    <h6>Live Video Streaming</h6>
                                    <p>Portabella supports a free add-on tunnel (Streamer) that is optimized for live video streaming from the field to any CDN or video server over the bonded 3G, 4G, LTE, 5G modems. This video-optimized bonding tunnel enables live video streaming applications to be 100% shielded from any network problems such as packet loss, latency, jitter, or even full modem disconnects. Even during those situations, your live video stream will continue without a glitch.</p>
                                    <h6>Ruggedized Design</h6>
                                    <p>Various Portabella models support embedded modems with high temperature and vibration tolerances, including train certifications. Other Portabella models support external USB-based modem ports for additional flexibility.</p>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella8000" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 8000 BROADBAND BONDING APPLICANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella8000} className="popup-img"
                                            alt="tms-portabella8000" title="tms-portabella8000" />
                                    </div>

                                </div>
                                <div>
                                    The Portabella 8000 Broadband Bonding Appliance, enables cost-effective and self-healing Internet access for mobile or remote setups. Aggregation and intelligent WAN orchestration of up to eight 3G/4G/LTE cellular wireless lines boosts Internet performance and reliability. The Portabella 8000 aggregates and intelligently orchestrates up to eight external usb based 3G/4G/LTE cellular modem dongles to increase performance and up-time of applications and services that run over the Internet. Up to eight 3G/4G/LTE cellular modems from the same or different carriers can be aggregated to provide increased bandwidth. The Portabella is ideal to boost the performance and reliability of real-time and non-real-time applications running over IP networks for vehicle and rail-road scenarios.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella8000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 8000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella8000i} className="popup-img"
                                            alt="tms-portabella8000i" title="tms-portabella8000i" />
                                    </div>

                                </div>
                                <div>
                                    The Portabella 8000i series Broadband Bonding Appliance, enables cost-effective and self-healing Internet access for mobile or remote setups. Aggregation and intelligent WAN orchestration of eight 3G/4G/LTE/5G cellular wireless lines boosts Internet performance and reliability. The Portabella 8000i aggregates and intelligently orchestrates up to eight embedded 3G/4G/LTE/5G cellular modems to increase performance and up-time of applications and services that run over the Internet. Eight 3G/4G/LTE/5G cellular modems from the same or different carriers can be aggregated to provide increased bandwidth. The Portabella is ideal to boost the performance and reliability of real-time and non-real-time applications running over IP networks for vehicle and rail-road scenarios.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella4000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 4000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella4000i} className="popup-img"
                                            alt="tms-portabella4000i" title="tms-portabella4000i" />
                                    </div>

                                </div>
                                <div>
                                    The Portabella 4000i series Broadband Bonding Appliance, enables cost-effective and self-healing Internet access for mobile or remote setups. Aggregation and intelligent WAN orchestration of four 3G/4G cellular SIM connections boosts Internet performance and reliability. The Portabella 4000i aggregates and intelligently orchestrates four embedded 3G/4G/LTE cellular modems to increase performance and up-time of applications and services that run over the Internet. Four 3G/4G/LTE cellular modems from the same or different carriers can be aggregated to provide increased bandwidth. The Portabella is ideal to boost the performance and reliability of real-time and non-real-time applications running over IP networks for vehicle and rail-road scenarios.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="portabella2000i" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    PORTABELLA 2000i SERIES BROADBAND BONDING APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={Portabella2000i} className="popup-img"
                                            alt="tms-portabella2000i" title="tms-portabella2000i" />
                                    </div>

                                </div>
                                <div>
                                    The Portabella 2000i series Broadband Bonding Appliance, enables cost-effective and self-healing Internet access for mobile or remote setups. Aggregation and intelligent WAN orchestration of two 3G/4G/5G cellular wireless lines boosts Internet performance and reliability. The Portabella 2000i aggregates and intelligently orchestrates two embedded 3G/4G/LTE/5G cellular modems to increase performance and up-time of applications and services that run over the Internet. Two 3G/4G/LTE/5G cellular modems from the same or different carriers can be aggregated to provide increased bandwidth. The Portabella is ideal to boost the performance and reliability of real-time and non-real-time applications running over IP networks for vehicle and rail-road scenarios.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="streamerpro" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    The Solution - Streamer PRO
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={StreamerPro} className="popup-img"
                                            alt="tms-streamer-pro" title="tms-streamer-pro" />
                                    </div>

                                </div>
                                <div>
                                    <h6>
                                        3G/4G/LTE/5G bonding
                                    </h6>
                                    <p className='mb-2'>
                                        Streamer PRO is a 3G/4G/LTE/5G bonding device that can broadcast live streaming video directly from your camera to a video server/CDN (Content Delivery Network) or directly to your studio. Since the video is streamed over the aggregated 3G/4G/LTE/5G cards with auto-error correction, your video stream can support high-quality video and will have unmatched professional-level reliability
                                    </p>
                                    <p>
                                        Webcasters can simply plug in the video feed from their camera (SDI, S-video, composite) or video switcher, add the USB modem cellular aircards to the Streamer PRO and broadcast live streaming video to their choice of CDN/video server. Similarly, Streamer PRO can send live video to a Mushroom Networks receiver with decoder at your studio for point-to-point video delivery.
                                    </p>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="trufflebroadband" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    TRUFFLE BROADBAND BONDING NETWORK APPLIANCE
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={TruffleBroadband} className="popup-img"
                                            alt="tms-truffle-broadband" title="tms-truffle-broadband" />
                                    </div>

                                </div>
                                <div>
                                    The Truffle Broadband Bonding Network Appliance, enables cost-effective Internet access solutions for any size businesses, apartments, hotels & other multi-tenant buildings who wish to aggregate multiple Internet access services for increased performance and reliability. The Truffle aggregates the capacity of four (or optionally as many as eight or twelve) DIA, DSL, fiber or cable modem services and two usb based cellular data card providing increased access bandwidth for downloaded HTTP traffic equal to the combined bandwidth of the aggregated links, even to a single user. The Truffle provides this higher access capacity and more reliable Internet access at a cost much lower than expensive MPLS or T-3 access service. It has a 1U rack-mountable form factor with silent active cooling.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="truffleex" role="dialog">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content m-0" style={{ paddingTop: "20px" }}>
                            <div className="modal-header mx-auto modal-header-part">
                                <span className="modal-header-part-span">
                                    Truffle-EX series Software Defined WAN Orchestration and Broadband Bonding Appliance
                                </span>

                                <button type="button" className="close x-button" data-dismiss="modal" style={{ fontSize: "24px" }}>
                                    ×
                                </button>
                            </div>
                            <div className="modal-body p-0" style={{ width: "95%", margin: "auto" }}>

                                <div style={{ textAlign: "center" }} >

                                    <div>
                                        <img src={TruffleEx} className="popup-img"
                                            alt="tms-truffle-ex" title="tms-truffle-ex" />
                                    </div>

                                </div>
                                <div>
                                    The Truffle-EX series Software Defined WAN Orchestration and Broadband Bonding Appliance, enables cost-effective and self-healing Internet access for businesses, enterprise branch offices and other multi-tenant buildings. Aggregation and intelligent WAN orchestration of multiple Internet access lines boosts Internet performance and reliability. The Truffle-EX aggregates and intelligently orchestrates up to four (or optionally as many as eight or twelve) Internet lines to increase performance and up-time of applications and services that run over the Internet. Several DIA, DSL, cable modem, MPLS, metro-ethernet or fiber services from different ISPs can be aggregated to provide increased bandwidth. The Truffle EX provides higher access capacity at a cost much lower than a single Internet access service and is ideal to boost the performance and reliability of real-time and non-real-time applications running over IP networks.
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" data-dismiss="modal">
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        )
    }
}
export default MushroomProducts;